import { Box, Collapse, Typography } from '@mui/material';
import {
  ContratoFormData,
  createContratoSchema,
} from '../../../schemas/contratoSchema';
import { FormProvider, useForm } from 'react-hook-form';

import Caution from '@assets/icons/caution-error.svg';
import EditalData from './EditalData';
import InsuredData from './InsuredData';
import { useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import TermsData from './TermsData';

interface ContractFormProps {
  onSubmit: (data: ContratoFormData) => void;
  limiteCredito: number;
  isSubmitting?: boolean;
  setErrorMessage: React.Dispatch<React.SetStateAction<string | null>>;
  timeoutProgress: number;
  defaultValues?: Partial<ContratoFormData>;
  errorMessage?: string | null;
}

const ContractForm = ({
  onSubmit,
  limiteCredito,
  isSubmitting,
  setErrorMessage,
  timeoutProgress,
  defaultValues,
  errorMessage,
}: ContractFormProps) => {
  const form = useForm<ContratoFormData>({
    resolver: zodResolver(createContratoSchema(limiteCredito, false)),
    mode: 'onChange',
    defaultValues,
  });

  const handleFormSubmit = (data: ContratoFormData) => {
    onSubmit(data);
  };

  useEffect(() => {
    setErrorMessage(null);
  }, [form.formState.errors, setErrorMessage]);

  return (
    <FormProvider {...form}>
      <Collapse in={Object.keys(form.formState.errors).length > 0}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            px: { xs: '24px', md: '88px' },
            py: '24px',
            backgroundColor: '#FF950026',
            borderRadius: '13px',
            mb: '16px',
          }}
        >
          <Box
            component="img"
            src={Caution}
            alt="Caution Icon"
            sx={{ width: { xs: '28px' }, height: { xs: '24px' } }}
          />
          <Typography
            sx={{ color: '#808080', fontSize: { xs: '14px', md: '16px' } }}
          >
            Alguns campos obrigatórios do formulário não foram preenchidos ou
            estão com informações incorretas. <br />
            Por favor, verifique se todos os campos com asterisco (*) foram
            preenchidos corretamente.
          </Typography>
        </Box>
      </Collapse>

      <Box
        component="form"
        onSubmit={form.handleSubmit(handleFormSubmit)}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          mb: { xs: '144px', sm: '0px' },
        }}
      >
        <EditalData isSubmitting={isSubmitting} />
        <InsuredData isSubmitting={isSubmitting} />
        <TermsData
          timeoutProgress={timeoutProgress}
          errorMessage={errorMessage}
          isSubmitting={isSubmitting}
        />
      </Box>
    </FormProvider>
  );
};

export default ContractForm;
